import * as React from 'react';
import { colors, fontFamily, fontSizes } from './styles';
import * as typestyle from 'typestyle';

export interface Props {
  content: React.ReactNode;
  htmlFor?: string;
  error?: string;
}
export interface State {
}

export namespace LabelStyles {
  /**
   * Based off of
   * https://app.frontify.com/d/zYF6HCW0aIp5/ui-library#/forms/text-inputs
   */
  export const rootClass = typestyle.style({
    fontFamily: fontFamily.arial,
    color: colors.warmGrey4,
    fontSize: fontSizes.label,
    transition: 'color .2s',
  });
  export const errorClass = typestyle.style({color:colors.red});
}

export class Label extends React.Component<Props, State> {
  render() {
    return (
      <label className={
        typestyle.classes(
          LabelStyles.rootClass,
          this.props.error && LabelStyles.rootClass
        )
      } htmlFor={this.props.htmlFor}>{this.props.content}</label>
    );
  }
}
